import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ce_admin_token");
    if (!token) { setChecking(false); return; }
    api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setAdmin(r.data))
      .catch(() => { localStorage.removeItem("ce_admin_token"); })
      .finally(() => setChecking(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ce_admin_token", r.data.token);
    setAdmin(r.data.admin);
    return r.data.admin;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ce_admin_token");
    setAdmin(null);
  }, []);

  return (
    <AuthContext.Provider value={{ admin, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};
